(function() {
  'use strict';
  angular.module('common')
  .directive('validEft', [ function() {
    var teldentMaxEftValue = 2147483647;
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function($scope, element, attrs, ngModelController) {
        ngModelController.$validators.eftMax = function(val) {
          if (!val) {
            return true;
          }
          return val <= teldentMaxEftValue;
        };
      }
    };
  }]);
})();
